import {toast} from "react-toastify";
import {translate} from "../../translate/translate";
import {AxiosError} from "axios";

// Status retornados pelo Nginx quando o backend está indisponível (ex.: durante atualização do sistema)
const SERVICE_UNAVAILABLE_STATUS = [502, 503, 504];

const isHtml = (data: any) => typeof data === "string" && /^\s*</.test(data);

export const ErrorComponent = (axiosError: AxiosError) => {
    const response = axiosError.response;
    if (axiosError.code === AxiosError.ERR_NETWORK
        || (response != undefined && SERVICE_UNAVAILABLE_STATUS.includes(response.status))) {
            // toastId evita várias mensagens iguais quando diversas requisições falham ao mesmo tempo
        toast.error(translate.t("service_unavailable"), {toastId: "service_unavailable"});
        return;
    } else if (response == undefined) {
        toast.error(translate.t(axiosError.message));
        return;
    } else if (response.status === 0 || isHtml(response.data)) {
        toast.error(translate.t("unknown_error"));
        return;
    }

    const isJson = (item: any) => {
        item = typeof item !== "string" ? JSON.stringify(item) : item;
        try {
            item = JSON.parse(item);
        } catch (e) {
            return false;
        }
        return typeof item === "object" && item !== null;
    };

    const captureError = () => {
        if (response.data instanceof Array) {
            return response.data;
        } else if (isJson(response.data)) {
            if (Object.values(response.data as object).every(item => item instanceof Array)) {
                const value = response.data as any;
                let errors: string[] = [];
                Object.keys(value).forEach((key: any) => {
                    if (value[key] instanceof Array) {
                        value[key].forEach((v: any) => {
                            if (typeof v === 'string') {
                                errors.push(translate.t(v.toString()));
                            } else {
                                Object.keys(v).forEach((k: any) => {
                                    if (v[k] instanceof Array) {
                                        v[k].forEach((i: any) => {
                                            errors.push(translate.t(i.toString()));
                                        });
                                        return;
                                    }
                                });
                            }
                        });
                        return;
                    }
                });
                return [errors];
            }
            return [response.data];
        }
        return [{detail: response.data}];
    };

    const errors = captureError();

    const showErrors = (value: any) => {
        Object.keys(value).forEach((key: any) => {
            toast.error(translate.t(value[key].toString()));
        });
    };

    errors.forEach(t => {
        if (t instanceof Blob) {
            const reader = new FileReader();
            reader.addEventListener("loadend", () => {
                showErrors(JSON.parse(reader.result ? reader.result.toString() : ""));
            });
            reader.readAsText(t);
        } else {
            showErrors(t);
        }
    });
};
